module.exports = __webpack_public_path__ + "static/media/javascript.c90ed54c.svg";